import { defineComponent as _defineComponent } from 'vue'
import annotationPlugin from 'chartjs-plugin-annotation';
import doughnutLabel from 'chartjs-plugin-doughnutlabel-rebourne';

import {
  Chart,
  ChartType,
  ChartData,
  ChartOptions,
  Point,
  DoughnutController,
  LineController,
  Tooltip,
  TimeScale,
  LinearScale,
  BarController,
  ArcElement,
  PointElement,
  CategoryScale,
  LineElement,
  BarElement,
  Filler,
  Legend,
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import cloneDeep from 'lodash/cloneDeep';
import { PropType, ref, watch, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VChart',
  props: {
    type: null,
    options: null,
    data: null
  },
  emits: ["update:chart"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:chart', value: Chart): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  type: string | PropType<ChartType>;
  options: ChartOptions;
  data: ChartData;
};

Chart.register(
  DoughnutController,
  LineController,
  Tooltip,
  TimeScale,
  LinearScale,
  BarController,
  ArcElement,
  PointElement,
  CategoryScale,
  BarElement,
  LineElement,
  Filler,
  annotationPlugin,
  Legend,
  doughnutLabel
);

const chartRef = ref<InstanceType<typeof HTMLCanvasElement> | null>(null);





let chart: Chart | undefined = undefined;

watch(
  () => props.options,
  () => {
    if (chart) {
      const options = cloneDeep(props.options);
      chart.options = options;
      chart.update('none');
    }
  }
);

/**
 * Update on dataset change, with 0 -> value animation (better when changing number of points)
 */
watch(
  () => props.data,
  () => {
    if (chart) {
      const zeroedData = {
        ...props.data,
        datasets: props.data.datasets?.map((d) => {
          const out = { ...d };
          if (out.data) {
            out.data = (out.data as Point[]).map((i) => {
              const out = { ...i };
              if (out.y) {
                out.y = 0;
              }
              return out;
            });
          }
          return out;
        }),
      };
      chart.data = zeroedData;
      chart.update('none');
      setTimeout(() => {
        chart!.data = props.data;
        chart!.update();
      });
    }
  }
);

onMounted(() => {
  const options = cloneDeep(props.options);
  const data = cloneDeep(props.data);

  chart = new Chart(chartRef.value!, {
    options,
    data,
    type: props.type as any,
  });
  emit('update:chart', chart);
});

return { __sfc: true,chartRef, props, emit, chart }
}

})